// extracted by mini-css-extract-plugin
module.exports = {"tippedInfo":"TippedItem_tippedInfo__MNzfk","tippedIcon":"TippedItem_tippedIcon__c0MP1","deletedUser":"TippedItem_deletedUser__Cbiq0"};